<div class="ui-g-12">
  <p-tabView [(activeIndex)]="this.packagesData.tabview_Data.selected_tab">
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Package Form" leftIcon="pi pi-pencil">
      <div class="ui-g">
        <ng-container *ngIf="
            !this.packagesData.packages_list_api_result.Posting &&
            this.packagesData.packages_list_api_result.PromiseResult.success
          ">
          <ng-container *ngIf="
              this.packagesData.package_status != null &&
              this.packagesData.package_status.length > 0
            ">
            <div class="ui-g-12">
              <div class="ui-g">
                <div class="card two-d-card mr-auto ml-auto mt-5 ui-g-12" style="padding-left: 10px">
                  <div class="card-body heading4">
                    <div class="ui-g-12" style="display: flex">
                      <!-- <div class="ui-g-12 ui-lg-6"> -->
                      <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-3">
                          <p class="status_heading">
                            <b> Subscription Status: </b>
                          </p>
                        </div>
                        <div class="ui-g-12 ui-lg-6">
                          <ng-container *ngFor="
                              let status of this.packagesData.package_status
                            ">
                            <div *ngIf="status.user_package_count.length">
                              <p class="heading3 egd-color">
                                {{ status.package_type.package_name }} Package
                                subscribed.
                              </p>
                              <p class="alert alert-success" *ngFor="
                                  let package_count of status.user_package_count
                                ">
                                <span class="notranslate">{{ package_count.current_count + ' ' }}</span>
                                {{
                                package_count.consultation_type
                                .consultation_name
                                }}
                                consultations left.
                              </p>
                              <div class="">
                                Valid Till-{{ status.expiry_date }}
                                <span *ngIf="status.has_extended">(Extended)</span>
                              </div>
                              <br />
                            </div>
                          </ng-container>
                        </div>
                        <!-- </div> -->
                        <div class="ui-g-12 ui-lg-3 text-center">
                          <p-button type="button" [style]="{
                              'margin-right': '5px',
                              display: 'flex',
                              'align-items': 'center',
                              'justify-content': 'center'
                            }" styleClass=" ui-button-rounded heading4" label="Consult Doctor"
                            (click)="RouterNavigation('consultdoctor')" [disabled]="isPosting()">
                          </p-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="this.packagesData.packages_india.length > 0">
            <form class="ui-g-12" accept-charset="UTF-8" #packageform="ngForm" (submit)="this.nextTab()">
              <div class="background_container">
                <div class="table-container mobile_view">
                  <div class="table-row">
                    <div class="table-cell" (click)="
                        openbasicfunction();
                        selectPackage(this.packagesData.packages_india[0].id)
                      ">
                      <div class="plan-name" style="font-weight: 900">
                        Basic Plan
                        <img src="../../../../assets/images/membership_plans/Icon-awesome-angle-right.png" />
                      </div>
                      <div class="price notranslate">
                        <span class="plan-name" style="text-decoration: line-through">₹999</span><br />
                        <span class="plan-name" style="font-weight: 900">
                          &nbsp;&nbsp;{{
                          this.packagesData.packages_india[0].renderedAmount
                          }}
                        </span>

                        <span class="discount">/{{
                          this.packagesData.packages_india[0].expiry
                          }}</span><br />

                        <span class="discount" style="color: green">Save 80%</span>
                        <br />
                      </div>
                      <div class="cell-plan-buy egd-color">Buy Plan</div>
                    </div>

                    <div class="table-cell" (click)="
                        openbasicplusfunction();
                        selectPackage(this.packagesData.packages_india[1].id)
                      ">
                      <div>
                        <button pButton type="button" class="bestseller_btn">
                          <i class="pi pi-star"></i> &nbsp;Recommended
                        </button>
                      </div>
                      <div class="plan-name" style="font-weight: 900">
                        Basic Plus Plan
                        <img src="../../../../assets/images/membership_plans/Icon-awesome-angle-right.png" />
                      </div>
                      <div class="price notranslate">
                        <span class="plan-name" style="text-decoration: line-through">₹1500 </span><br />
                        <span class="plan-name" style="font-weight: 900">
                          &nbsp;&nbsp;{{
                          this.packagesData.packages_india[1].renderedAmount
                          }}
                        </span>

                        <span class="discount">/{{
                          this.packagesData.packages_india[1].expiry
                          }}</span><br />
                        <span class="discount" style="color: green">Save 74%</span>
                        <br />
                      </div>
                      <div class="cell-plan-buy egd-color">Buy Plan</div>
                    </div>

                    <div class="table-cell" (click)="
                        openprofunction();
                        selectPackage(this.packagesData.packages_india[2].id)
                      ">
                      <div class="plan-name" style="font-weight: 900">
                        Pro Plan
                        <img src="../../../../assets/images/membership_plans/Icon-awesome-angle-right.png" />
                      </div>
                      <div class="price notranslate">
                        <span class="plan-name" style="text-decoration: line-through">₹2100 </span><br />
                        <span class="plan-name" style="font-weight: 900">
                          &nbsp;&nbsp;{{
                          this.packagesData.packages_india[2].renderedAmount
                          }}
                        </span>

                        <span class="discount">/{{
                          this.packagesData.packages_india[2].expiry
                          }}</span><br />

                        <span class="discount" style="color: green">Save 67%</span>
                        <br />
                      </div>
                      <div class="cell-plan-buy egd-color">Buy Plan</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ui-g-12 mobile_view_1">
                <div class="ui-g-12">
                  <div class="diet_plan_table1">
                    <p class="diet_plan_title egd-color">
                      Select a eGlobalDoctors Membership Plan
                    </p>

                    <br />
                    <div class="ui-g-12 diet_plan_header">
                      <div class="ui-g-3 small_screen">
                        eGlobalDoctors Benefits :
                        <p class="header_down">
                          Experience best care at affordable pricing
                        </p>
                      </div>
                      <div class="ui-g-3 text-align-center">
                        {{ this.packagesData.packages_india[0].package_name }}
                        <p class="header_down">
                          Covers <span class="notranslate"> 1 </span> Person<br />
                          Valid for
                          {{ this.packagesData.packages_india[0].expiry }}
                        </p>
                      </div>
                      <div class="ui-g-3 text-align-center" style="
                          position: relative;
                          background: transparent;
                          z-index: 0;
                        ">
                        <div class="background-layer" style="z-index: -1; padding: 0px"></div>
                        <div>
                          {{ this.packagesData.packages_india[1].package_name }}
                          <p class="header_down">
                            Covers <span class="notranslate"> 1 </span> Person<br />
                            Valid for
                            {{ this.packagesData.packages_india[1].expiry }}
                          </p>
                        </div>
                        <div style="
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                          ">
                          <button pButton type="button" class="bestseller_btn">
                            <i class="pi pi-star"></i> &nbsp;Recommended
                          </button>
                        </div>
                      </div>
                      <div class="ui-g-3 text-align-center">
                        {{ this.packagesData.packages_india[2].package_name }}
                        <p class="header_down">
                          Covers <span class="notranslate"> 1 </span> Person<br />
                          Valid for
                          {{ this.packagesData.packages_india[2].expiry }}
                        </p>
                      </div>
                    </div>

                    <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                      <div class="ui-g-3" style="font-weight: 900">
                        <span class="notranslate">24/7 </span> Access to Board Certified Doctors Across <span class="notranslate"> many </span>
                        Specialties
                      </div>
                      <div class="ui-g-3 text-align-center cell_back">
                        <img src="../../../../assets/images/membership_plans/cross_icon.png " alt="tick" />
                      </div>
                      <div class="ui-g-3 text-align-center">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                      <div class="ui-g-3 text-align-center">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                    </div>

                    <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                      <div class="ui-g-3" style="font-weight: 900">
                        Premium Support Care
                      </div>
                      <div class="ui-g-3 text-align-center cell_back">
                        <img src="../../../../assets/images/membership_plans/cross_icon.png " alt="tick" />
                      </div>
                      <div class="ui-g-3 text-align-center">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                      <div class="ui-g-3 text-align-center">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                    </div>

                    <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1" *ngIf="!this.is_uk_country">
                      <div class="ui-g-3" style="font-weight: 900">
                        No. of Diet Consultation
                        <span style="color: red"> &nbsp;FREE</span>
                      </div>
                      <div class="ui-g-3 text-align-center cell_back notranslate">
                        {{ this.packagesData.packages_india[0].description[1] }}
                      </div>
                      <div class="ui-g-3 text-align-center notranslate">
                        {{ this.packagesData.packages_india[1].description[1] }}
                      </div>
                      <div class="ui-g-3 text-align-center notranslate">
                        {{ this.packagesData.packages_india[2].description[1] }}
                      </div>
                    </div>

                    <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                      <div class="ui-g-3" style="font-weight: 900">
                        <span class="notranslate">1 </span> Week Detox Plan
                        <span style="color: red"> &nbsp;FREE</span>
                      </div>
                      <div class="ui-g-3 text-align-center cell_back">
                        <img src="../../../../assets/images/membership_plans/cross_icon.png " alt="tick" />
                      </div>
                      <div class="ui-g-3 text-align-center">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                      <div class="ui-g-3 text-align-center">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                    </div>

                    <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                      <div class="ui-g-3" style="font-weight: 900">
                        <span class="notranslate">15% </span> OFF on Pharmacy Order
                      </div>
                      <div class="ui-g-3 text-align-center cell_back">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                      <div class="ui-g-3 text-align-center">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                      <div class="ui-g-3 text-align-center">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                    </div>

                    <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                      <div class="ui-g-3" style="font-weight: 900">
                        <span class="notranslate">15% </span> OFF on Diagnostics Order
                      </div>
                      <div class="ui-g-3 text-align-center cell_back">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                      <div class="ui-g-3 text-align-center">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                      <div class="ui-g-3 text-align-center">
                        <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                          alt="tick" />
                      </div>
                    </div>
                    <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                      <div class="ui-g-3" style="font-weight: 900">
                        Health Passport Access
                        <p class="notranslate">
                          <span style="color: red; text-decoration: line-through">₹500</span>&nbsp; ₹0
                        </p>
                      </div>
                      <div class="ui-g-3 text-align-center cell_back">
                        {{ this.packagesData.packages_india[0].expiry }}
                      </div>
                      <div class="ui-g-3 text-align-center cell_back">
                        {{ this.packagesData.packages_india[1].expiry }}
                      </div>
                      <div class="ui-g-3 text-align-center">
                        {{ this.packagesData.packages_india[2].expiry }}
                      </div>
                    </div>
                    <div class="ui-g-12 diet_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                      <div class="ui-g-3" style="font-weight: 900">
                        Number of Consultations
                      </div>
                      <div class="ui-g-3 text-align-center cell_back">
                        {{ this.packagesData.packages_india[0].description[0] }}
                      </div>
                      <div class="ui-g-3 text-align-center cell_back">
                        {{ this.packagesData.packages_india[1].description[0] }}
                      </div>
                      <div class="ui-g-3 text-align-center">
                        {{ this.packagesData.packages_india[2].description[0] }}
                      </div>
                    </div>

                    <div class="ui-g-12 diet_plan_cell buy_plan notranslate" style="z-index: 1">
                      <div class="ui-g-3"></div>
                      <div class="ui-g-3 text-align-center cell_back_1">
                        <div>
                          <span style="text-decoration: line-through">₹999</span><br />
                          <span class="discount">&nbsp;&nbsp;{{
                            this.packagesData.packages_india[0].renderedAmount
                            }}</span>
                          / {{ this.packagesData.packages_india[0].expiry }}
                          <br />
                          <div class="ui-g-12"></div>
                          <span class="discount" style="color: green">Save 80%
                          </span>
                          <br />
                        </div>
                      </div>
                      <div class="ui-g-3 text-align-center cell_back_1">
                        <div>
                          <span style="text-decoration: line-through">₹1500 </span><br />
                          <span class="discount">&nbsp;&nbsp;{{
                            this.packagesData.packages_india[1].renderedAmount
                            }}</span>
                          / {{ this.packagesData.packages_india[1].expiry }}
                          <br />
                          <div class="ui-g-12"></div>
                          <span class="discount" style="color: green">Save 74%
                          </span>
                          <br />
                        </div>
                      </div>
                      <div class="ui-g-3 text-align-center cell_back_1">
                        <div>
                          <span style="text-decoration: line-through">₹2100 </span><br />
                          <span class="discount">&nbsp;&nbsp;{{
                            this.packagesData.packages_india[2].renderedAmount
                            }}</span>
                          / {{ this.packagesData.packages_india[2].expiry }}
                          <br />
                          <div class="ui-g-12"></div>
                          <span class="discount" style="color: green">Save 67%
                          </span>
                          <br />
                        </div>
                      </div>
                    </div>

                    <div class="ui-g-12 diet_plan_cell">
                      <div class="ui-g-3"></div>
                      <div *ngFor="let package of packagesData.packages_india" class="ui-g-3 text-align-center">
                        <p-button pRipple type="button"
                          [styleClass]="isCurrentPackageSelected(package.id) ? 'ui-button-success ui-button-rounded' : 'ui-button-rounded'"
                          [icon]="isCurrentPackageSelected(package.id) ? 'pi pi-check' : 'pi pi-plus'"
                          [label]="isCurrentPackageSelected(package.id) ? 'SELECTED' : 'SELECT'"
                          (click)="selectPackage(package.id)">
                        </p-button>
                      </div>
                    </div>
                    

                    <hr />
                  </div>
                </div>
                <div class="ui-g-12 text-center">
                  <p-button [style]="{ 'margin-right': '5px' }" label="Continue to Payment"
                    styleClass="heading4 p-button-lg ui-button-rounded"
                    [disabled]="!packageform.valid || isPosting() || !(this.isCurrentPackageSelected(this.packagesData.packages_india[2].id) || this.isCurrentPackageSelected(this.packagesData.packages_india[1].id) || this.isCurrentPackageSelected(this.packagesData.packages_india[0].id))">
                  </p-button>
                </div>
              </div>

              <p-dialog *ngIf="this.basicvisible" header="Basic Plan" [(visible)]="this.basicvisible" [modal]="true">
                <div class="ui-g-12 popup-container">
                  <img src="../../../../assets/images/membership_plans/Intersection-54-02.png" class="image-size" />

                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <div class="popup-plan-name">
                        Basic Plan <br /><span class="sub-popup">{{
                          this.packagesData.packages_india[0].description[0]
                          }}</span><br />
                        <span class="sub-popup">Valid for
                          {{ this.packagesData.packages_india[0].expiry }}</span>
                      </div>
                    </div>
                    <div class="ui-g-6 text-center">
                      <div>
                        <span class="discount notranslate" style="text-decoration: line-through">₹999</span><br />
                        <span class="popup-plan-name notranslate">
                          &nbsp;&nbsp;{{
                          this.packagesData.packages_india[0].renderedAmount
                          }} </span>/<span class="discount">&nbsp;&nbsp;{{
                          this.packagesData.packages_india[0].expiry
                          }}</span>
                        <br />
                        <span class="discount1 notranslate" style="color: green">Save 80%</span>
                      </div>
                    </div>
                    <br />
                    <br />
                    <div class="ui-g-12 notranslate">
                      <span class="bullet-point">
                        <span class="bullet-text">24/7 Access to Board Certified Doctors across
                          many specialities</span> </span><br />
                      <span class="bullet-point"><span class="bullet-text">Premium Support Care</span></span><br />
                      <span class="bullet-point" *ngIf="!this.is_uk_country">
                        <span class="bullet-text">{{
                          this.packagesData.packages_india[0].description[1] +
                          ' Diet Consultation'
                          }}</span> </span><br />
                      <span class="bullet-point">
                        <span class="bullet-text">15% OFF on Pharmacy and Diagnostics Order</span> </span><br />
                      <span class="bullet-point">
                        <span class="bullet-text">Health Passport Access for
                          <span class="notranslate">{{ this.packagesData.packages_india[0].expiry }}</span></span>
                      </span>
                    </div>
                    <br />
                    <br />
                    <div class="ui-g-6">
                      <div class="popup-plan-name">
                        <span class="sub-popup">Amount to Pay</span><br />
                        <span class="notranslate">&nbsp;&nbsp;{{
                          this.packagesData.packages_india[0].renderedAmount
                          }}</span>
                      </div>
                    </div>
                    <div class="ui-g-6" style="font-size: 13px">
                      <div class="text-center">
                        <p-button label="Continue to Pay" styleClass="ui-button-rounded "
                          [disabled]="!packageform.valid || isPosting()">
                        </p-button>
                      </div>
                    </div>
                  </div>
                </div>
              </p-dialog>

              <p-dialog *ngIf="this.basicplusvisible" header="Basic Plus Plan" [(visible)]="this.basicplusvisible"
                [modal]="true">
                <div class="ui-g-12 popup-container">
                  <img src="../../../../assets/images/membership_plans/Intersection-54-02.png" class="image-size" />

                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <div class="popup-plan-name">
                        Basic Plus Plan <br /><span class="sub-popup">{{
                          this.packagesData.packages_india[1].description[0]
                          }}</span><br />
                        <span class="sub-popup">Valid for
                          {{ this.packagesData.packages_india[1].expiry }}</span>
                      </div>
                    </div>
                    <div class="ui-g-6 text-center">
                      <div>
                        <span class="discount notranslate" style="text-decoration: line-through">₹1500</span><br />
                        <span class="popup-plan-name notranslate">
                          &nbsp;&nbsp;{{
                          this.packagesData.packages_india[1].renderedAmount
                          }} </span>/<span class="discount">&nbsp;&nbsp;{{
                          this.packagesData.packages_india[1].expiry
                          }}</span>
                        <br />
                        <span class="discount1 notranslate" style="color: green">Save 74%</span>
                      </div>
                    </div>
                    <br />
                    <br />
                    <div class="ui-g-12 notranslate">
                      <span class="bullet-point">
                        <span class="bullet-text">
                          24/7 Access to Board Certified Doctors across many specialities
                        </span> 
                      </span> <br />
                      <span class="bullet-point">
                        <span class="bullet-text">
                          Premium Support Care
                        </span>
                      </span> <br />
                      <span class="bullet-point" *ngIf="!this.is_uk_country">
                        <span class="bullet-text">{{
                          this.packagesData.packages_india[1].description[1] +
                          ' Diet Consultation'
                          }}
                        </span> 
                      </span> <br />
                      <span class="bullet-point">
                        <span class="bullet-text">
                          15% OFF on Pharmacy and Diagnostics Order
                        </span> 
                      </span> <br />
                      <span class="bullet-point">
                        <span class="bullet-text">Health Passport Access for
                          {{ this.packagesData.packages_india[1].expiry }}
                        </span>
                      </span>
                    </div>
                    <br />
                    <br />
                    <div class="ui-g-6">
                      <div class="popup-plan-name">
                        <span class="sub-popup">Amount to Pay</span><br />
                        <span class="notranslate">&nbsp;&nbsp;{{
                          this.packagesData.packages_india[1].renderedAmount
                          }}</span>
                      </div>
                    </div>
                    <div class="ui-g-6" style="font-size: 13px">
                      <div class="text-center">
                        <p-button label="Continue to Pay" styleClass="ui-button-rounded "
                          [disabled]="!packageform.valid || isPosting()">
                        </p-button>
                      </div>
                    </div>
                  </div>
                </div>
              </p-dialog>

              <p-dialog *ngIf="this.provisible" header="Pro Plan" [(visible)]="this.provisible" [modal]="true">
                <div class="ui-g-12 popup-container">
                  <img src="../../../../assets/images/membership_plans/Intersection-54-02.png" class="image-size" />

                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <div class="popup-plan-name">
                        Pro Plan <br /><span class="sub-popup">{{
                          this.packagesData.packages_india[2].description[0]
                          }}</span><br />
                        <span class="sub-popup">Valid for
                          {{ this.packagesData.packages_india[2].expiry }}</span>
                      </div>
                    </div>
                    <div class="ui-g-6 text-center">
                      <div>
                        <span class="discount notranslate" style="text-decoration: line-through ">₹2100</span><br />
                        <span class="popup-plan-name notranslate">
                          &nbsp;&nbsp;{{
                          this.packagesData.packages_india[2].renderedAmount
                          }} </span>/<span class="discount">&nbsp;&nbsp;{{
                          this.packagesData.packages_india[2].expiry
                          }}</span>
                        <br />
                        <span class="discount1 notranslate" style="color: green">Save 67%</span>
                      </div>
                    </div>
                    <br />
                    <br />
                    <div class="ui-g-12 notranslate">
                      <span class="bullet-point">
                        <span class="bullet-text">24/7 Access to Board Certified Doctors across
                          manyspecialities</span> </span><br />
                      <span class="bullet-point"><span class="bullet-text">Premium Support Care</span></span><br />
                      <span class="bullet-point" *ngIf="!this.is_uk_country">
                        <span class="bullet-text">{{
                          this.packagesData.packages_india[2].description[1] +
                          ' Diet Consultation'
                          }}</span> </span><br />
                      <span class="bullet-point">
                        <span class="bullet-text">15% OFF on Pharmacy and Diagnostics Order</span> </span><br />
                      <span class="bullet-point">
                        <span class="bullet-text">Health Passport Access for
                          {{ this.packagesData.packages_india[2].expiry }}</span>
                      </span>
                    </div>
                    <br />
                    <br />
                    <div class="ui-g-6">
                      <div class="popup-plan-name">
                        <span class="sub-popup">Amount to Pay</span><br />
                        <span class="notranslate"> &nbsp;&nbsp;{{
                          this.packagesData.packages_india[2].renderedAmount
                          }}</span>
                      </div>
                    </div>
                    <div class="ui-g-6" style="font-size: 13px">
                      <div class="text-center">
                        <p-button label="Continue to Pay" styleClass="ui-button-rounded "
                          [disabled]="!packageform.valid || isPosting()">
                        </p-button>
                      </div>
                    </div>
                  </div>
                </div>
              </p-dialog>

              <div class="ui-g-12 text-center">
                <app-loading type="SMALL_LOADER" *ngIf="isPosting()"></app-loading>
              </div>
            </form>
          </ng-container>
          <div class="ui-g-12 text-align-center">
            <div style="display: flex; justify-content: center">
              <p style="font-size: x-large; font-weight: bolder; color: #004aad">
                Benefits of eGlobalDoctors Membership Plan
              </p>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="benefit_icons">
              <div class="ui-g-4 ui-sm-12" style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  text-align: center;
                ">
                <!-- <div style="height: 80px; width: 80px; border-radius: 50%; background: transparent linear-gradient(180deg, #236ABC 0%, #6BAEDB 100%) 0% 0% no-repeat padding-box;"></div> -->
                <img src="../../../../assets/images/membership_plans/icon1.png" height="60px" width="60px"
                  alt="Best Doctors" />
                <p style="margin-top: 15px">
                  Board Certified Doctors
                  from across the world.
                </p>
              </div>

              <div class="ui-g-4 ui-sm-12" style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  text-align: center;
                ">
                <!-- <div style="height:80px;width:80px;border-radius: 50%;background: transparent linear-gradient(180deg, #236ABC 0%, #6BAEDB 100%) 0% 0% no-repeat padding-box;;"> -->
                <img src="../../../../assets/images/membership_plans/icon2.png" height="60px" width="60px" alt="many" />

                <p style="margin-top: 15px">40 + Specialities</p>
              </div>

              <div class="ui-g-4 ui-sm-12" style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  text-align: center;
                ">
                <!-- <div style="height:80px;width:80px;border-radius: 50%;background: transparent linear-gradient(180deg, #236ABC 0%, #6BAEDB 100%) 0% 0% no-repeat padding-box;;"></div> -->
                <img src="../../../../assets/images/membership_plans/icon 3.png" height="60px" width="60px"
                  alt="calender" />
                <p style="margin-top: 15px">24*7 Doctors availability</p>
              </div>
            </div>
          </div>

          <div class="ui-g-12 text-align-center">
            <div style="display: flex; justify-content: center">
              <p style="font-size: x-large; font-weight: bolder; color: #004aad">
                eGlobalDoctors <span class="notranslate">vs</span> Other Healthcare Providers
              </p>
            </div>
          </div>

          <div class="ui-g-12">
            <div class="diet_plan_table">
              <div class="ui-g-12 header_row" style="border-radius: 15px 15px 0 0; background: #e2eefd">
                <div class="ui-g-4 header_cell" style="text-align: center">
                  Benefits :
                </div>
                <div class="ui-g-4 WordWrap header_cell" style="background: #fdf0e2; text-align: center">
                  eGlobalDoctors<br />
                  <p class="header_down">Covers <span class="notranslate"> 1 </span></p>
                </div>
                <div class="ui-g-4 header_cell_1" style="
                    border-radius: 0 15px 0 0;
                    background: #fdf0e2;
                    text-align: center;
                  ">
                  Other Healthcare Providers<br />
                  <p class="header_down">Covers <span class="notranslate"> 1 </span> Person</p>
                </div>
              </div>

              <div class="ui-g-12 diet_plan_row">
                <div class="ui-g-4 diet_plan_cell" style="
                    font-weight: 900;
                    background: #e2eefd;
                    border-right: 1px solid #999999;
                  ">
                  <span style="margin-left: 10px"> <span class="notranslate"> 24/7 </span> Doctors Availability</span>
                </div>
                <div class="ui-g-4 diet_plan_cell_1">
                  <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
                </div>
                <div class="ui-g-4 text-align-center">
                  <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
                </div>
              </div>

              <div class="ui-g-12 diet_plan_row">
                <div class="ui-g-4 diet_plan_cell" style="
                    font-weight: 900;
                    background: #e2eefd;
                    border-right: 1px solid #999999;
                  ">
                  <span style="margin-left: 10px">Premium Support Care</span>
                </div>
                <div class="ui-g-4 diet_plan_cell_1">
                  <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
                </div>
                <div class="ui-g-4 text-align-center">
                  <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
                </div>
              </div>

              <div class="ui-g-12 diet_plan_row" *ngIf="!this.is_uk_country">
                <div class="ui-g-4 diet_plan_cell" style="
                    font-weight: 900;
                    background: #e2eefd;
                    border-right: 1px solid #999999;
                  ">
                  <span style="margin-left: 10px"> <span class="notranslate"> 1 </span> Diet Consultation<span style="color: red">&nbsp;FREE</span></span>
                </div>
                <div class="ui-g-4 diet_plan_cell_1">
                  <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
                </div>
                <div class="ui-g-4 text-align-center">
                  <img src="../../../../assets/images/membership_plans/cross_icon.png" alt="tick" />
                </div>
              </div>

              <div class="ui-g-12 diet_plan_row">
                <div class="ui-g-4 diet_plan_cell" style="
                    font-weight: 900;
                    background: #e2eefd;
                    border-right: 1px solid #999999;
                  ">
                  <span style="margin-left: 10px"> <span class="notranslate"> 1 </span> Week Detox Plan<span style="color: red">&nbsp;FREE</span></span>
                </div>
                <div class="ui-g-4 diet_plan_cell_1">
                  <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
                </div>
                <div class="ui-g-4 text-align-center">
                  <img src="../../../../assets/images/membership_plans/cross_icon.png" alt="tick" />
                </div>
              </div>
              <div class="ui-g-12 diet_plan_row">
                <div class="ui-g-4 diet_plan_cell" style="
                    font-weight: 900;
                    background: #e2eefd;
                    border-right: 1px solid #999999;
                  ">
                  <span style="margin-left: 10px">Health Passport access</span>
                </div>
                <div class="ui-g-4 diet_plan_cell_1">
                  <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png" alt="tick" />
                </div>
                <div class="ui-g-4 text-align-center">
                  <img src="../../../../assets/images/membership_plans/cross_icon.png" alt="tick" />
                </div>
              </div>
              <div class="ui-g-12 diet_plan_row">
                <div class="ui-g-4 diet_plan_cell" style="
                    font-weight: 900;
                    background: #e2eefd;
                    border-right: 1px solid #999999;
                  ">
                  <span style="margin-left: 10px">Number of Specialties</span>
                </div>
                <div class="ui-g-4 diet_plan_cell_1"> <span class="notranslate"> many </span></div>
                <div class="ui-g-4 text-align-center diet_plan_cell_2">22+</div>
              </div>
              <div class="ui-g-12 diet_plan_row">
                <div class="ui-g-4 diet_plan_cell" style="
                    font-weight: 900;
                    border-radius: 0 0 0 25px;
                    background: #e2eefd;
                    border-right: 1px solid #999999;
                    overflow: hidden;
                  ">
                  <span style="margin-left: 10px">Response Time</span>
                </div>
                <div class="ui-g-4 diet_plan_cell_1">Within  <span class="notranslate"> 30 </span> Mins</div>
                <div class="ui-g-4 text-align-center diet_plan_cell_2">
                  <span class="notranslate"> 2-3 </span> hrs
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="ui-g-12">
          <app-error-messages [api_result]="this.packagesData.packages_list_api_result">
          </app-error-messages>
        </div>
      </div>
      <div class="ui-g">
        <div style="text-align: center" class="ui-g-12">
          <p style="color: #004aad; font-size: x-large; font-weight: bolder">
            Worried about your medical needs in USA?
          </p>
          <p style="color: #004aad; font-size: x-large; font-weight: bolder">
            Checkout Our Health Packages
          </p>
        </div>
        <ng-container *ngIf="
            !this.packagesData.packages_list_api_result.Posting &&
            this.packagesData.packages_list_api_result.PromiseResult.success
          ">
          <ng-container *ngIf="this.packagesData.packages_usa_india.length > 0">
            <form class="ui-g-12" accept-charset="UTF-8" #packageform="ngForm" (submit)="this.nextTab()">
              <div class="card-deck mt-5 ui-g-12">
                <div class="ui-g" style="display: flex; justify-content: center">
                  <div *ngFor="let package of this.packagesData.packages_usa_india" class="ui-g-12 ui-md-6 ui-lg-4">
                    <div class="card packages-card" [style]="'background-color:' + package.color_code">
                      <div class="card-body">
                        <div class="ui-g">
                          <div class="ui-g-6">
                            <img [src]="package.image_web" />
                          </div>
                          <div class="ui-g-6 text-right">
                            <img class="pkgpricingimg" [src]="package.price_image" />
                          </div>
                        </div>
                        <div class="ui-g">
                          <div class="ui-g-12">
                            <h5 class="margin-0 package-name card-title font-weight-bolder heading2">
                              {{ package.package_name }}
                            </h5>
                            <div class="card-text">
                              <ul class="heading4">
                                <li class="card-li-txt" *ngFor="let desc of package.description">
                                  {{ desc }}
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="ui-g-12 text-center">
                            <p-button pRipple type="button"
                              [styleClass]="isCurrentPackageSelectedTravelling(package.id) ? 'ui-button-success ui-button-rounded' : 'ui-button-rounded'"
                              [icon]="isCurrentPackageSelectedTravelling(package.id) ? 'pi pi-check' : 'pi pi-plus'"
                              [label]="isCurrentPackageSelectedTravelling(package.id) ? 'SELECTED' : 'SELECT'"
                              (click)="selectPackageTravelling(package.id)">
                            </p-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>

              <div class="ui-g-12 text-center">
                <p-button type="submit" [style]="{ 'margin-right': '5px' }" label="Continue to Payment"
                  styleClass="heading4 p-button-lg ui-button-rounded"
                  [disabled]="!packageform.valid || isPosting() ||  !(this.isCurrentPackageSelectedTravelling(this.packagesData.packages_usa_india[0].id) || this.isCurrentPackageSelectedTravelling(this.packagesData.packages_usa_india[1].id) || this.isCurrentPackageSelectedTravelling(this.packagesData.packages_usa_india[2].id))">
                </p-button>
              </div>
              <div class="ui-g-12 text-center">
                <app-loading type="SMALL_LOADER" *ngIf="isPosting()"></app-loading>
              </div>
            </form>
            <div class="ui-g-12">
              <div class="card two-d-card mr-auto ml-auto mt-5">
                <div class="card-body">
                  <h5 class="card-title egd-color font-weight-bolder ml-1 heading2" style="margin: 10px">
                    Features
                  </h5>

                  <div class="card-text">
                    <ul class="font-weight-bold">
                      <li class="card-li-txt heading5">
                        <span *ngIf="this.is_uk_country">Access to GMC registered UK specialist doctors.</span><span *ngIf="!this.is_uk_country">Access to doctors from USA, UK, India and other parts of
                          the world</span>
                        <a class="egd-color show_click" target="viewAllDoctors" (click)="
                            openLink(
                              'HOMPAGE_BASE_URL',
                              'view-doctors',
                              'eGlobalDoctors-View-All-Doctors'
                            )
                          ">
                         <span *ngIf="this.is_primary_provider">(View Doctors)</span> 
                        </a>
                        <i class="fa fa-arrow-left arrowfeatures heading3 alert alert-danger" aria-hidden="true"></i>
                      </li>
                      <li class="card-li-txt heading5">
                        Our Specialties - Internal Medicine, Cardiology,
                        Orthopedics, Oncology, Pediatrics, Psychiatry and many
                        more.
                        <a class="egd-color show_click" target="viewAllSpecialties" (click)="
                            openLink(
                              'HOMPAGE_BASE_URL',
                              'view-specialties',
                              'eGlobalDoctors-View-All-specialties'
                            )
                          ">
                          <span *ngIf="this.is_primary_provider">(View Specialties)</span>
                        </a>
                        <i class="fa fa-arrow-left arrowfeatures heading3 alert alert-danger" aria-hidden="true"></i>
                      </li>
                      <li class="card-li-txt heading5">
                        Prescription will be provided.
                      </li>
                      <li class="card-li-txt heading5">
                        Response time 1 - 3 days.
                      </li>

                      <li class="card-li-txt heading5">
                        Family Members can participate live via Video Physician
                        Consultation from any part of the world.
                      </li>
                      <li class="card-li-txt heading5">
                        Video Consultation upto 30 minutes.
                      </li>

                      <li class="card-li-txt heading5">
                        No restrictions on pre existing medical conditions.
                      </li>
                      <li class="card-li-txt heading5">
                        In-app messaging with doctor after consultation.
                      </li>
                      <li class="card-li-txt heading5">
                        ID and Portable Health Passports.
                      </li>
                      <li class="card-li-txt heading5">
                        These packages are applicable only for Primary
                        Consultations and <span *ngIf="!this.is_uk_country">Expert Second Medical Opinion.</span><span *ngIf="this.is_uk_country">Specialist Consultation</span>
                      </li>
                      <li class="card-li-txt heading5">
                        Package subscription can be extended; it cannot be
                        canceled.
                      </li>
                      <li class="card-li-txt heading5">
                        If the subscribed package is not used in 6 months from
                        the date of purchase; subscription can be extended to
                        one year.
                      </li>
                      <li class="card-li-txt heading5">
                        The numbers are subject to change under the authority of
                        eGlobalDoctors.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class="ui-g-12">
          <app-error-messages [api_result]="this.packagesData.packages_list_api_result">
          </app-error-messages>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Payment" leftIcon="pi pi-pencil">
      <div class="ui-g">
        <p class="heading2 egd-theme-text">Payment</p>
        <app-payment class="ui-g-12" [payment_data]="this.packagesData.paymentData"
          (payment_success)="onPaymentSuccess($event)"></app-payment>
        <div class="ui-g-12 text-align-right" *ngIf="!isPosting()">
          <p-button type="button" [style]="{
              'margin-right': '5px',
              'margin-top': '3px',
              'background-color': 'white',
              color: '#004AAD',
              'border-radius': '5px'
            }" (click)="prevTab()" label="Back" class="p-button-lg" icon="pi pi-arrow-left">
          </p-button>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Transaction Successful" leftIcon="pi pi-pencil">
      <p-dialog *ngIf="this.packagesData.print_data.displayModal" header="Invoice"
        [(visible)]="this.packagesData.print_data.displayModal" [modal]="true" [style]="{ width: '50vw' }">
        <div class="ui-g-12">
          <app-loading type="LOADING_DATA" *ngIf="this.packagesData.print_data.api_result.Posting">
          </app-loading>
        </div>
        <ng-container *ngIf="
            !this.packagesData.print_data.api_result.Posting &&
            this.packagesData.print_data.api_result.PromiseResult.success !=
              null &&
            this.packagesData.print_data.api_result.PromiseResult.success
          ">
          <div class="ui-g-12">
            <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text">
            </p-button>
          </div>
          <div *ngIf="
              this.packagesData.print_data.api_result.PromiseResult.success !=
                null &&
              this.packagesData.print_data.api_result.PromiseResult.success
            ">
            <div class="spaces"></div>
            <app-invoicedetails class="notranslate" [data]="this.packagesData.print_data.data"
              [dataId]="this.packagesData.print_data.showInvoice">
            </app-invoicedetails>
          </div>
        </ng-container>
      </p-dialog>
      <div *ngIf="
          this.packagesData.print_data.api_result.PromiseResult.success !=
            null &&
          this.packagesData.print_data.api_result.PromiseResult.success
        ">
        <div class="spaces"></div>

        <app-invoicedetails class="notranslate" [data]="this.packagesData.print_data.data"
          [dataId]="this.packagesData.print_data.printContent">
        </app-invoicedetails>
      </div>
      <div class="ui-g text-center">
        <div class="ui-g-12">
          <img src="assets/images/thank-you/successful.gif" alt="" class="successful-logo" />
        </div>
        <div class="ui-g-12">
          <h2 class="egd-theme-text">Thank you for purchasing the package</h2>
        </div>
        <div class="ui-g-12">Transaction Successful</div>

        <div class="ui-g-12 transaction-success-buttons">
          <button pButton type="button" class="button-size" style="margin-right: 5px" label="Consult Doctor"
            (click)="RouterNavigation('consultdoctor')"></button>
          <button pButton type="button" style="margin-right: 5px" class="button-size" label="Navigate to Transactions"
            (click)="RouterNavigation('transactions')"></button>
          <!-- <p-button
            type="button"
            [style]="{ 'margin-right': '5px' }"
            label="Print Invoice"
            icon="pi pi-print"
            (click)="openInvoice()"
          >
          </p-button> -->
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
  <div class="ui-g-12">
    <app-loading type="LOADING_DATA" *ngIf="isPosting()"></app-loading>
  </div>
</div>